'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useCallback } from 'react';
import { useRefinementList } from 'react-instantsearch';
import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
const ClearAllFiltersButtonComponent = () => {
  const $ = _c(12);
  const {
    isReadyToShipActive,
    handleToggleReadyToShip,
    minWidth,
    maxWidth,
    handleWidthChange
  } = useAdvancedSearchContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      attribute: "type"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    items,
    refine
  } = useRefinementList(t0);
  let t1;
  if ($[1] !== items) {
    t1 = items?.some(_temp) || false;
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const hasActiveProductTypes = t1;
  const hasActiveWidth = !!(minWidth || maxWidth);
  const hasActiveFilters = isReadyToShipActive || hasActiveWidth || hasActiveProductTypes;
  let t2;
  if ($[3] !== handleToggleReadyToShip || $[4] !== handleWidthChange || $[5] !== hasActiveProductTypes || $[6] !== hasActiveWidth || $[7] !== isReadyToShipActive || $[8] !== refine) {
    t2 = () => {
      if (isReadyToShipActive) {
        handleToggleReadyToShip?.(false);
      }
      if (hasActiveWidth) {
        handleWidthChange?.("", "");
      }
      if (hasActiveProductTypes) {
        refine([]);
      }
    };
    $[3] = handleToggleReadyToShip;
    $[4] = handleWidthChange;
    $[5] = hasActiveProductTypes;
    $[6] = hasActiveWidth;
    $[7] = isReadyToShipActive;
    $[8] = refine;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleClearAll = t2;
  if (!hasActiveFilters) {
    return null;
  }
  let t3;
  if ($[10] !== handleClearAll) {
    t3 = <div className="md:pb-5"><ClearAllFiltersButton onClick={handleClearAll}>Clear all</ClearAllFiltersButton></div>;
    $[10] = handleClearAll;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default ClearAllFiltersButtonComponent;
function _temp(item) {
  return item.isRefined;
}